import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateCustomFieldPositions as UpdateCustomFieldPositionsMutation,
    UpdateCustomFieldPositionsVariables as UpdateCustomFieldPositionsVariables,
    CustomFieldUpdatePositionInput,
} from 'nutshell-graphql-types';

import UPDATE_CUSTOM_FIELD_POSITIONS from '../mutations/update-custom-field-positions.graphql';
import GET_CUSTOM_FIELD_STAGESETS from '../queries/get-custom-field-stagesets.graphql';
import GET_CUSTOM_FIELDS from '../queries/get-custom-fields.graphql';

export const useUpdateCustomFieldPositions = (): {
    updateCustomFieldPositions: (arg1: CustomFieldUpdatePositionInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateCustomFieldPositions, {loading, error}] = useMutation<
        UpdateCustomFieldPositionsMutation,
        UpdateCustomFieldPositionsVariables
    >(UPDATE_CUSTOM_FIELD_POSITIONS);

    return {
        updateCustomFieldPositions: (input: CustomFieldUpdatePositionInput) => {
            return updateCustomFieldPositions({
                variables: {input},
                refetchQueries: [
                    {
                        query: GET_CUSTOM_FIELDS,
                        variables: {
                            input: {
                                entityType: input.entityType,
                            },
                        },
                    },
                    {
                        query: GET_CUSTOM_FIELD_STAGESETS,
                    },
                ],
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
